import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    ChangeEvent,
    FC,
    KeyboardEvent,
} from 'react';

import {
    ErrorMessage,
} from 'components/other';

import styles from './MultilineInput.module.scss';

const MultilineInput: FC<IProps> = (props) => {
    const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        let {value} = e.target;

        if (props.maxLength !== undefined) {
            if (value.length === props.maxLength + 1) {
                return;
            }

            value = value.slice(0, props.maxLength);
        }

        e.target.value = value;

        props.onChangeValue?.(e.target.value);
        props.onChange?.(e);
    };
    const onKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
        // @ts-ignore
        const {value, selectionStart, selectionEnd} = e.target;

        if (props.maxLength !== undefined) {
            if (value.length === props.maxLength) {
                const isSystem = e.metaKey || e.ctrlKey || e.altKey;
                const isSelected = selectionEnd - selectionStart > 0;

                if (e.key.length === 1 && !isSystem && !isSelected) {
                    e.preventDefault();
                }
            }
        }

        props.onKeyDown?.(e);
    };

    return (
        <div
            className={
                classNames(styles.multilineInput, props.className, {
                    [styles.isDisabled]: props.isDisabled,
                    [styles.isError]: props.isError,
                })
            }
        >
            {
                props.label &&
                <label className={styles.label}>
                    {props.label}
                </label>
            }
            <textarea
                className={styles.input}
                value={props.value}
                placeholder={props.placeholder}
                rows={props.rows}
                disabled={props.isDisabled}
                onChange={onChange}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                onKeyDown={onKeyDown}
            />
            <ErrorMessage
                className={styles.errorMessage}
                text={props.errorMessage ?? ''}
            />
        </div>
    );
};

export default MultilineInput;
